import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

const Privacy = () => (
  <LegalLayout title="Politique de confidentialité" updated="Août 2026">
    <p>
      Chez VÉLIS, nous accordons une grande importance à la protection de votre vie privée. Cette
      politique explique quelles données sont utilisées, pourquoi elles le sont et les choix dont vous
      disposez.
    </p>

    <Section heading="1. Données collectées">
      <p>
        VÉLIS collecte uniquement les informations nécessaires au fonctionnement de l’application,
        notamment :
      </p>
      <ul className="list-disc pl-6 space-y-1">
        <li>votre adresse courriel et les informations nécessaires à votre compte;</li>
        <li>les missions, expéditions, priorités et autres contenus que vous créez;</li>
        <li>vos points et données de progression;</li>
        <li>
          certaines données techniques ou d’utilisation nécessaires au fonctionnement, à l’amélioration
          et à l’analyse de l’application.
        </li>
      </ul>
      <p>
        Ces données sont associées à votre compte afin que vous puissiez les retrouver lors de vos
        prochaines utilisations.
      </p>
    </Section>

    <Section heading="2. Utilisation des données">
      <p>Vos données sont utilisées pour :</p>
      <ul className="list-disc pl-6 space-y-1">
        <li>fournir les fonctionnalités de VÉLIS;</li>
        <li>sauvegarder et afficher vos missions, expéditions et votre progression;</li>
        <li>assurer le fonctionnement et la sécurité de votre compte;</li>
        <li>comprendre de façon générale comment l’application est utilisée et améliorer l’expérience.</li>
      </ul>
      <p>Nous ne vendons pas vos renseignements personnels. Ils peuvent toutefois être communiqués à des fournisseurs de services lorsque cela est nécessaire au fonctionnement, à la sécurité ou à l’analyse de VÉLIS.</p>
    </Section>

    <Section heading="3. Analyse d’utilisation">
      <p>
        VÉLIS peut utiliser des outils d’analyse afin de mesurer de façon générale l’utilisation de
        certaines fonctionnalités et d’améliorer l’application.
      </p>
      <p>
        Ces données sont utilisées uniquement dans le cadre du fonctionnement, de l’analyse et de
        l’amélioration de VÉLIS.
      </p>
    </Section>

    <Section heading="Fournisseurs de services et traitement hors Québec">
      <p>
        Certaines données peuvent être traitées par des fournisseurs technologiques utilisés pour
        l’hébergement, le fonctionnement, la sécurité ou l’analyse de VÉLIS. Certains de ces fournisseurs
        peuvent traiter des renseignements à l’extérieur du Québec.
      </p>
    </Section>

    <Section heading="4. Sécurité">
      <p>
        Nous appliquons des mesures techniques et organisationnelles raisonnables afin de protéger vos
        informations contre l’accès, l’utilisation ou la divulgation non autorisés.
      </p>
    </Section>

    <Section heading="5. Conservation et suppression">
      <p>
        Vos données sont conservées aussi longtemps que votre compte est actif ou qu’elles sont
        nécessaires au fonctionnement du service.
      </p>
      <p>
        Vous pouvez supprimer votre compte directement depuis VÉLIS. La suppression du compte entraîne la
        suppression des données associées conformément au processus prévu dans l’application.
      </p>
    </Section>

    <Section heading="6. Vos droits">
      <p>
        Vous pouvez demander l’accès, la correction ou la suppression de vos renseignements personnels
        et, lorsque la loi le permet, retirer votre consentement. Vous pouvez également nous transmettre
        une question ou une plainte concernant la protection de vos renseignements personnels.
      </p>
    </Section>

    <Section heading="7. Modifications de cette politique">
      <p>
        Cette politique peut être mise à jour afin de refléter les changements apportés à VÉLIS ou à nos
        pratiques. La date de dernière mise à jour sera indiquée au haut de cette page.
      </p>
    </Section>

    <Section heading="Responsable de la protection des renseignements personnels">
      <p>
        Pour toute question, demande ou plainte concernant vos renseignements personnels ou cette
        politique :{" "}
        <a className="text-velis-orange" href="mailto:support@velisproductivity.com">
          support@velisproductivity.com
        </a>
      </p>
    </Section>
  </LegalLayout>
);

export default Privacy;
